import { useEffect, useState } from 'react';
import type { TrackedValue } from 'state/secondaryMarket/realtime/realtime.model';

export const useTrackedValue = (value?: number) => {
  const [val, setValue] = useState(value);
  const [trackedValue, setTrackedValue] = useState<TrackedValue>();
  useEffect(() => {
    if ((value ?? 0) > (val ?? 0)) {
      setTrackedValue({ trend: 'increase', value });
    } else if ((value ?? 0) < (val ?? 0)) {
      setTrackedValue({ trend: 'decrease', value });
    }
    setValue(value);
  }, [value, val]);
  return trackedValue;
};
